import { useRef, useState, useCallback } from "react";
import { MoveHorizontal } from "lucide-react";

export default function BeforeAfter({ before, after, alt = "Before and after comparison" }) {
  const ref = useRef(null);
  const [pos, setPos] = useState(50);
  const dragging = useRef(false);

  const update = useCallback((clientX) => {
    const r = ref.current?.getBoundingClientRect();
    if (!r) return;
    setPos(Math.min(97, Math.max(3, ((clientX - r.left) / r.width) * 100)));
  }, []);

  const onPointerDown = (e) => {
    dragging.current = true;
    e.currentTarget.setPointerCapture?.(e.pointerId);
    update(e.clientX);
  };
  const onPointerMove = (e) => {
    if (dragging.current) update(e.clientX);
  };
  const stop = () => (dragging.current = false);

  return (
    <div
      ref={ref}
      data-testid="before-after-slider"
      className="relative aspect-[4/3] sm:aspect-[16/10] overflow-hidden select-none touch-none cursor-ew-resize border border-white/10"
      onPointerDown={onPointerDown}
      onPointerMove={onPointerMove}
      onPointerUp={stop}
      onPointerLeave={stop}
      role="slider"
      aria-label="Before and after comparison slider"
      aria-valuenow={Math.round(pos)}
    >
      <img src={after} alt={`${alt} — after`} className="absolute inset-0 w-full h-full object-cover" draggable={false} />
      <div className="absolute inset-0 overflow-hidden" style={{ width: `${pos}%` }}>
        <img
          src={before}
          alt={`${alt} — before`}
          className="absolute inset-0 h-full object-cover"
          style={{ width: ref.current ? ref.current.clientWidth : "100%" }}
          draggable={false}
        />
      </div>
      <div className="absolute top-0 bottom-0 w-[2px] bg-arsenal shadow-[0_0_14px_rgba(229,9,20,0.8)]" style={{ left: `${pos}%` }}>
        <span className="absolute top-1/2 -translate-y-1/2 -translate-x-1/2 left-0 flex h-10 w-10 items-center justify-center rounded-full bg-arsenal text-white shadow-lg">
          <MoveHorizontal className="h-5 w-5" />
        </span>
      </div>
      <span className="absolute top-3 left-3 clip-tag bg-black/70 backdrop-blur px-3 py-1.5 font-mono text-[10px] tracking-[0.25em] text-slate-300">ORIGINAL</span>
      <span className="absolute top-3 right-3 clip-tag bg-arsenal px-3 py-1.5 font-mono text-[10px] tracking-[0.25em] text-white">ARSENAL ARTISTS</span>
    </div>
  );
}
